import { combineReducers } from 'redux'

import domain from './domain'
import ui from './ui'

export default combineReducers({
  domain,
  ui,
})
